export const faqs = [
  {
    question: 'What should I bring to a notary appointment?',
    answer:
      'Bring the complete document and acceptable, current identification for each signer. Do not sign a document in advance when the notarial act requires Michael to witness the signature. Ask when scheduling if you are unsure.',
  },
  {
    question: 'Is an appointment request automatically confirmed?',
    answer:
      'No. Your request starts the scheduling process. Michael will review the details, confirm availability, and provide final service and travel pricing before the appointment is scheduled.',
  },
  {
    question: 'Can Michael explain my document or tell me which form to use?',
    answer:
      'No. Square & Compass Notary does not provide legal advice, select legal forms, or explain the legal effect of a document. Contact a licensed attorney for legal guidance.',
  },
  {
    question: 'Can every document be notarized online?',
    answer:
      'No. Electronic notarization depends on the document, signer, jurisdiction, and platform requirements. Eligibility is confirmed before an e-notary session is scheduled.',
  },
  {
    question: 'Are travel fees included in service prices?',
    answer:
      'Travel fees are listed separately unless a service description specifically includes travel. Final service and travel fees will be confirmed before the appointment is scheduled.',
  },
  {
    question: 'Does Square & Compass Notary issue apostilles?',
    answer:
      'No. Apostilles are issued by the appropriate government authority. Michael provides administrative assistance, document handling, submission support, and courier coordination.',
  },
  {
    question: 'Can a notary certify a copy of any document?',
    answer:
      'No. Eligibility depends on the document type and applicable law. Some documents must be obtained as certified copies from the agency or custodian that issued them.',
  },
  {
    question: 'What information should I avoid sending through the website?',
    answer:
      'Do not submit Social Security numbers, identification images, banking information, medical records, confidential legal documents, or document uploads through the forms.',
  },
] as const
